import { render, staticRenderFns } from "./SurveyChart.vue?vue&type=template&id=c5ec2428"
import script from "./SurveyChart.vue?vue&type=script&lang=js"
export * from "./SurveyChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports